module.exports = __webpack_public_path__ + "static/media/piggy_bank.59be2ec1.webp";